// extracted by mini-css-extract-plugin
export default {"section":"About_section__O1rjF","about":"About_about__6ibv3"};